// extracted by mini-css-extract-plugin
module.exports = {"block":"dmbc-common_list-block","list":"dmbc-common_list-list","img":"dmbc-common_list-img"};